export default {
  title: "Configurare",
  description: "Gestioneaza setari generale",
  fixed_value: "valoare fixa",
  no_future_values: "Nu exista valori viitoare",
  current_value: "Valoare curenta",
  current_value_lei: "Valoare curenta Lei",
  current_euro_value: "Valoare curenta EUR",
  new_value: "Valori viitoare",
  new_value_lei: "Valori viitoare Lei",
  new_euro_value: "Valori viitoare EUR",
  parameter_name: "Nume parametru",
  percent: "procent",
  tooltips: {
      current_value_info_bnr: "Valoarea in lei va fi calculata automat la cursul BNR",
      euro_exchange_checkbox: "Daca aceast checkbox este bifat, se foloseste valoarea in EUR si echivalentul in lei " +
          "este calculat automat la cursul BNR. Daca nu este bifata, se ia in considerare doar valoarea introdusa in lei",
  },
  table: {
    new_config: "Adauga configurare",
    edit_config: "Modifica configurarea",
    current_value: "Valoare curenta",
    current_value_eur: "Valoare curenta EUR",
    future_value: "Valoare viitoare",
    future_value_eur: "Valoare viitoare EUR",
  }
}
